import * as React from 'react';
import styled from 'styled-components';

import { EventDetailGrid } from '@process-advisor/process-miner/model/events/eventDetailGrid';
import { getShadow, getZIndex } from '@process-advisor/process-miner/shared/theme';

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    box-shadow: ${getShadow('pane')};
    z-index: ${getZIndex('panel')};
    padding-bottom: 5px;
`;


export const EventDetail = () => {
    return (
        <Wrapper>
            <EventDetailGrid/>
        </Wrapper>

    );
};
